import Vue from 'vue/dist/vue.esm';
import VueResource from 'vue-resource';

Vue.use(VueResource);

function searchTerm(id, value, values, _destroy) {
  return { id: id, value: value, values: values, _destroy: _destroy };
}

function newSearchTerm() {
  return searchTerm(null, '', {}, null);
}

function initSearchClause(search_clause) {
  search_clause._destroy = null;

  if(!search_clause.search_terms) {
    search_clause.search_terms = [];
  }

  if(search_clause.search_terms.length === 0) {
    search_clause.search_terms.push(newSearchTerm());
  }

  search_clause.search_terms.forEach(function(search_term) {
    search_term._destroy = null;
  });
}

function hideSaveBtn() {
  var saveBtn = document.getElementById('save-search-btn')
  if(saveBtn){
    saveBtn.style.display = "none";
  }
}

Vue.component('selectize-input', {
  props: ['value', 'name', 'id', 'placeholder', 'endpoint', 'query-param', 'dependent-input-base-id', 'dependent-param-id','other-dependent-param-id', 'create', 'value-field', 'label-field', 'initial-options'],
  template: '<select class="form-control select" :name="name" :id="id" :placeholder="placeholder" data-type="select2"></select>',
  mounted: function () {
    let _this = this,
        data = [];
    if (_this.initialOptions && _this.initialOptions.length > 0) {
      for(let key in _this.initialOptions) {
        let initialOption = _this.initialOptions[key];
        data.push({ id: initialOption[_this.valueField], text: initialOption[_this.labelField] });
      }
    }

    const $select = $(_this.$el);
    const isInsideModal = $select.closest('.modal').length > 0;

    // Function to initialize Select2
    const initializeSelect2 = function() {
      if ($select.hasClass('select2-hidden-accessible')) {
        return; // Already initialized
      }

      $select.select2({
        data: data,
        ajax: {
          url: _this.endpoint,
          dataType: 'json',
          delay: 250,
          cache: true,
          data: function (params) {
            let requestParams = { q: params.term, type: 'select2', page: (params.page || 1) };

            if(_this.dependentParamId) {
              let dependentValue;
              // Find the dependent element within the same form context
              const formContainer = $select.closest('.dynamic-search-form, #dynamic-search-form-inline');
              const dependentElement = formContainer.find(`#${_this.dependentInputBaseId}_${_this.dependentParamId}`);

              if(dependentElement.length > 0) {
                dependentValue = dependentElement.val();
              }

              if(dependentValue) {
                requestParams[_this.dependentParamId] = dependentValue;
              }
            }

            if(_this.otherDependentParamId) {
              let otherDependentValue;
              // Find the other dependent element within the same form context
              const formContainer = $select.closest('.dynamic-search-form, #dynamic-search-form-inline');
              const otherDependentElement = formContainer.find(`#${_this.dependentInputBaseId}_${_this.otherDependentParamId}`);

              if(otherDependentElement.length > 0) {
                otherDependentValue = otherDependentElement.val();
              }

              if(otherDependentValue) {
                requestParams[_this.otherDependentParamId] = otherDependentValue
              }
            }

            return requestParams;
          }
        },
        closeOnSelect: true
      });

      // Set initial value if provided
      if (_this.value) {
        $select.val(_this.value).trigger('change.select2');
      }
    };

    // If inside modal, set up multiple initialization triggers
    if (isInsideModal) {
      const modal = $select.closest('.modal');
      
      // Initialize when modal is shown
      modal.on('shown.bs.modal.select2-init', function() {
        initializeSelect2();
      });
      
      // Also try to initialize immediately if modal is already visible
      if (modal.hasClass('show')) {
        setTimeout(initializeSelect2, 100);
      }
      
      // Add a mutation observer to catch dynamically added fields
      const observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
          if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
            // Check if any added nodes contain our select element
            for (let node of mutation.addedNodes) {
              if (node.nodeType === Node.ELEMENT_NODE) {
                if (node.contains(_this.$el) || node === _this.$el) {
                  setTimeout(initializeSelect2, 50);
                  break;
                }
              }
            }
          }
        });
      });
      
      // Start observing the modal for changes
      observer.observe(modal[0], {
        childList: true,
        subtree: true
      });
      
      // Clean up observer when component is destroyed
      _this.$once('hook:beforeDestroy', function() {
        observer.disconnect();
      });
    } else {
      // Initialize immediately if not in a modal
      initializeSelect2();
    }
    
    // Add event listeners for Select2 change events
    $select.on('change', function(e) {
      // Update the Vue model with the selected value
      const selectedValue = $select.val();
      _this.$emit('input', selectedValue);

      // Find the search clause index from the element ID
      let searchClauseIndex = -1;
      const idParts = _this.id.split('_');
      for (let i = 0; i < idParts.length; i++) {
        if (idParts[i] === 'search' && idParts[i+1] === 'clauses' && idParts[i+2] === 'attributes') {
          searchClauseIndex = parseInt(idParts[i+3]);
          break;
        }
      }

      const isInsideInlineFilterForm = $(e.target).closest('#dynamic-search-form-inline').length > 0;

      if (isInsideInlineFilterForm) {
        // Find the Vue root instance
        let formElement = document.getElementById('dynamic-search-form-inline');
        if (formElement && formElement.__vue__ && searchClauseIndex >= 0) {
          // Submit the form after a short delay to ensure the model is updated
          setTimeout(() => {
            formElement.__vue__.submitForm();
          }, 200);
        }
      }

      return true;
    });
  },
  beforeDestroy: function() {
    if ($(this.$el).data('select2')) {
      $(this.$el).off('change');
      $(this.$el).select2('destroy');
    }
  },
  watch: {
    value: function(newVal) {
      // Update the select2 when the v-model changes from outside
      if ($(this.$el).val() !== newVal) {
        $(this.$el).val(newVal).trigger('change.select2');
      }
    }
  }
});

document.addEventListener('turbo:load', initializeDynamicSearchForms, false);
document.addEventListener('turbo:frame-load', initializeDynamicSearchForms, false);

export function initializeDynamicSearchForms(){
  Vue.http.headers.common['X-CSRF-Token'] = document.querySelector('meta[name="csrf-token"]').getAttribute('content');

  let elements = document.querySelectorAll('.dynamic-search-form:not(.is--initialized)');

  if(elements.length > 0){
    
    for(var i = 0; i < elements.length; i ++) {
      const element = elements[i];
      element.classList.add("is--initialized");

      var search_clauses_attributes = JSON.parse(element.dataset.searchClausesAttributes);
      var search_options = JSON.parse(element.dataset.searchOptions);
      var initialSearchKeys = element.dataset.initialSearchKeys || '';

      // If no search clauses exist, add one automatically
      if (!search_clauses_attributes || search_clauses_attributes.length === 0) {
        var searchOptionKeys = initialSearchKeys.split(',') 
        if (JSON.stringify(searchOptionKeys) === JSON.stringify([''])){
          searchOptionKeys = [Object.keys(search_options)[0]];
        }

        if(searchOptionKeys.length > 0){
          search_clauses_attributes = searchOptionKeys.map(function (searchOptionKey) {
            var searchOption = search_options[searchOptionKey];

            if (searchOption){
              var a = {
                id: null,
                search_key: searchOptionKey,
                custom_attribute_id: searchOption.custom_attribute_id,
                search_comparator: searchOption.comparators[0][0],
                search_terms: [newSearchTerm()],
                _destroy: null
              }
              return a
            }
          });
        }
      } else {
        search_clauses_attributes.forEach(initSearchClause);
      }

      const dynamicSearchApp = new Vue({
        el: element,
        data: function() {
          return {
            inputTimer: null,
            search_options: search_options,
            search_clauses_attributes: search_clauses_attributes,
            years_for_model: function(search_key, model_id) {
              var years = [],
                  data = search_options[search_key].years[model_id],
                  year_start = data.start,
                  year_end = data.end;

              for(var year = year_end; year >= year_start; year --) years.push(year);

              return years;
            },
            newSearchTerm: newSearchTerm,
            initSearchClause: function(searchClause, searchKey) {
              var searchOptions = search_options[searchKey];
              searchClause.search_comparator = searchOptions.comparators[0][0];
              searchClause.search_terms = [newSearchTerm()];

              if(searchOptions.custom_attribute_id) {
                searchClause.custom_attribute_id = searchOptions.custom_attribute_id;
              }
            }
          }
        },
        methods: {
          submitForm: function() {
            this.$nextTick(function() {
              const searchBtn = document.querySelector('.search-btn');
              if (searchBtn) {
                searchBtn.click();
              }
            });
          },
          isInsideModal: function() {
            // Check if this Vue instance is inside a modal
            return this.$el && this.$el.closest('.modal') !== null;
          },
          shouldAutoSubmit: function() {
            // Only auto-submit if not inside a modal (i.e., for inline forms)
            return !this.isInsideModal();
          },
          checkAndSubmitSearchClause: function(clauseIndex) {
            // Only check the specific clause that was modified
            if (this.isSearchClauseComplete(clauseIndex)) {
              this.submitForm();
            }
          },
          isSearchClauseComplete: function(clauseIndex) {
            const clause = this.search_clauses_attributes[clauseIndex];
            if (!clause || clause._destroy === 1) {
              return false;
            }
            
            // Check if search_key and search_comparator are selected
            if (!clause.search_key || !clause.search_comparator) {
              return false;
            }
            
            // Skip value check for 'is_blank' comparator which doesn't need a value
            if (clause.search_comparator === 'is_blank') {
              return true;
            }
            
            // Check if at least one search term has a value
            const activeSearchTerms = clause.search_terms.filter(term => term._destroy !== 1);
            
            for (let j = 0; j < activeSearchTerms.length; j++) {
              const term = activeSearchTerms[j];
              // Check if term has a non-empty value (including "false" string)
              if ((term.value !== null && term.value !== undefined && term.value !== '') || 
                  (term.values && Object.values(term.values).some(v => v !== null && v !== undefined && v !== ''))) {
                return true;
              }
            }
            
            return false;
          },
          areAllSearchClausesComplete: function() {
            // Used for the X button removal - we don't need to check completeness
            return true;
          },
          handleSelectChange: function(event) {
            // Extract the clause index from the element ID
            const target = event.target;
            const idParts = target.id.split('_');
            let clauseIndex = -1;
            
            for (let i = 0; i < idParts.length; i++) {
              if (idParts[i] === 'search' && idParts[i+1] === 'clauses' && idParts[i+2] === 'attributes') {
                clauseIndex = parseInt(idParts[i+3]);
                break;
              }
            }
            
            if (clauseIndex >= 0) {
              // For select elements, we can check immediately
              this.checkAndSubmitSearchClause(clauseIndex);
            }
          },
          handleInputChange: function(event) {
            // Extract the clause index from the element ID
            const target = event.target;
            const idParts = target.id.split('_');
            let clauseIndex = -1;
            
            for (let i = 0; i < idParts.length; i++) {
              if (idParts[i] === 'search' && idParts[i+1] === 'clauses' && idParts[i+2] === 'attributes') {
                clauseIndex = parseInt(idParts[i+3]);
                break;
              }
            }
            
            // Use debounce to wait for typing to finish
            if (this.inputTimer) {
              clearTimeout(this.inputTimer);
            }
            
            if (clauseIndex >= 0) {
              this.inputTimer = setTimeout(() => {
                this.checkAndSubmitSearchClause(clauseIndex);
              }, 500); // Wait 500ms after typing stops
            }
          },
          addSearchClause: function(searchOption) {
            var firstKey = Object.keys(this.search_options)[0];
            // Get the actual search option object using the key
            var searchOptionObj = this.search_options[firstKey];

            this.search_clauses_attributes.push({
              id: null,
              search_key: firstKey,
              custom_attribute_id: searchOptionObj.custom_attribute_id,
              search_comparator: searchOptionObj.comparators[0][0],
              search_terms: [newSearchTerm()],
              _destroy: null
            });

            // Initialize Select2 for any new dynamically added fields
            this.$nextTick(() => {
              this.initializeNewSelect2Fields();
            });
          },
          initializeNewSelect2Fields: function() {
            // Find any uninitialized Select2 elements within this Vue instance
            const $container = $(this.$el);
            const uninitializedSelects = $container.find('select[data-type="select2"]:not(.select2-hidden-accessible)');
            
            uninitializedSelects.each(function() {
              const $select = $(this);
              // Trigger the selectize-input component's mounted hook manually
              if ($select.closest('[data-type="select2"]').length > 0) {
                // Find the Vue component instance and call its initialization
                const selectElement = $select[0];
                if (selectElement.__vue__) {
                  selectElement.__vue__.$forceUpdate();
                }
              }
            });
            
            // Also trigger initialization for any selectize-input components
            this.$nextTick(() => {
              // Find all selectize-input components that might need initialization
              const selectizeComponents = $container.find('select[data-type="select2"]');
              selectizeComponents.each(function() {
                const $select = $(this);
                if (!$select.hasClass('select2-hidden-accessible')) {
                  // This select hasn't been initialized yet
                  const vueComponent = $select[0].__vue__;
                  if (vueComponent && typeof vueComponent.$options.mounted === 'function') {
                    // Call the mounted hook to initialize Select2
                    vueComponent.$options.mounted.call(vueComponent);
                  }
                }
              });
              
              // For modal context, also trigger modal shown event to ensure initialization
              const modal = $container.closest('.modal');
              if (modal.length > 0 && modal.hasClass('show')) {
                modal.trigger('shown.bs.modal.select2-init');
              }
            });
          },
          removeSearchClause: function(searchClause) {
            searchClause._destroy = 1;
            // Only auto-submit if not inside a modal (for inline forms only)
            if (this.shouldAutoSubmit()) {
              this.submitForm();
            }
          },
          addSearchTerm: function(searchClause) {
            searchClause.search_terms.push(newSearchTerm())
          },
          isAllowRemoveSearchClause: function() {
            return true;
          },
          removeSearchTerm: function(searchClause, searchTerm) {
            searchTerm._destroy = 1;
            // Only auto-submit if not inside a modal (for inline forms only)
            if (this.shouldAutoSubmit()) {
              this.submitForm();
            }
          },
          showSearchTermSeparator: function(searchClause, index) {
            var i = index - 1;
            while(i >= 0) {
              if(searchClause.search_terms[i]._destroy !== 1) {
                return true;
              }

              i --;
            }

            return false;
          },
          showSearchTermAddBtn: function(searchClause, index) {
            // only show if the searchClause is the last one (not destroyed)
            for (var i = index + 1; i < searchClause.search_terms.length; i ++) {
              if(searchClause.search_terms[i]._destroy !== 1) {
                return false;
              }
            }

            return true;
          },
          showSearchTermRemoveBtn: function(searchClause, index) {
            var activeTermsCount = 0;
            for(var i = 0; i < searchClause.search_terms.length; i ++) {
              if(searchClause.search_terms[i]._destroy !== 1) {
                activeTermsCount ++;
              }
            }

            return activeTermsCount > 1;
          }
        }
      });
    }
  }
}

document.addEventListener("turbo:before-cache", function () {
  document.querySelectorAll('.dynamic-search-form.is--initialized').forEach((element) => {
    element.classList.remove('is--initialized');
  });
});
